type TawkApi = {
  onLoad?: () => void;
  onChatMaximized?: () => void;
  onChatMinimized?: () => void;
  onChatHidden?: () => void;
  showWidget?: () => void;
  maximize?: () => void;
};

type TawkWindow = Window & { Tawk_API?: TawkApi; Tawk_LoadStart?: Date };

const TAWK_SRC = "https://embed.tawk.to/6ab8da99e281453444a82b1a/1k3h1bqnk";
const readyEvent = "blycare:tawk-ready";
let waitingForWidget = false;

/** 部署环境且非 SSO 时加载 Tawk 客服脚本。 */
export function loadSupportChat() {
  const tawkWindow = window as TawkWindow;
  const api = (tawkWindow.Tawk_API ??= {});
  tawkWindow.Tawk_LoadStart = new Date();
  api.onLoad = () => window.dispatchEvent(new Event(readyEvent));
  api.onChatMaximized = () => window.dispatchEvent(new Event("blycare:tawk-opened"));
  api.onChatMinimized = () => window.dispatchEvent(new Event("blycare:tawk-closed"));
  api.onChatHidden = () => window.dispatchEvent(new Event("blycare:tawk-closed"));

  const script = document.createElement("script");
  script.async = true;
  script.src = TAWK_SRC;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");
  document.head.appendChild(script);
}

function showSupportChat() {
  const api = (window as TawkWindow).Tawk_API;
  if (typeof api?.showWidget !== "function" || typeof api.maximize !== "function") {
    return false;
  }

  api.showWidget();
  api.maximize();
  return true;
}

export function openSupportChat() {
  if (showSupportChat() || waitingForWidget) return;

  waitingForWidget = true;
  window.addEventListener(
    readyEvent,
    () => {
      waitingForWidget = false;
      showSupportChat();
    },
    { once: true },
  );
}
